/**
 * Pagination Constants
 */

export const ITEMS_PER_PAGE = 10;

